import { Navigate, Outlet, useMatch, useOutletContext } from "react-router-dom";

import MENU_ITEMS from "@/core/navbar/services/menuItems";

import { useFarmModules } from "./FarmModulesProvider";

const ModuleRouteGuard = (): React.ReactElement => {
  const match = useMatch("/farm/:farmId/:section/*");
  const { isDisabled } = useFarmModules();
  const outletContext = useOutletContext();

  const moduleKey = MENU_ITEMS.find(
    (item) => item.route.split("/")[0] === match?.params.section,
  )?.moduleKey;

  if (moduleKey && isDisabled(moduleKey)) {
    return <Navigate replace to={`/farm/${match?.params.farmId}/map`} />;
  }

  return <Outlet context={outletContext} />;
};

export { ModuleRouteGuard };
